import { motion } from "framer-motion";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
}

const SectionHeading = ({ title, subtitle, centered = true }: SectionHeadingProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6 }}
      className={`mb-10 sm:mb-14 ${centered ? "text-center" : ""}`}
    >
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-gradient-ocean">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-3 font-body text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
          {subtitle}
        </p>
      )}
      <div className={`mt-4 h-0.5 w-16 bg-accent rounded-full ${centered ? "mx-auto" : ""}`} />
    </motion.div>
  );
};

export default SectionHeading;
